import { getSizeByRoomCount } from "../../RoomCards/hooks/useSetCardSize"

export const useSetSkeletonCardSize = (grid: { rows: number; cols: number } | null) => {
    const size = getSizeByRoomCount(grid ? grid.rows * grid.cols : 0)

    return { size }
}
